import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPenToSquare } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, t, ...rest }) => {
	const columns = [
		{
			header: t('Term_Name'),
			accessor: 'name',
			sortable: true
		},
		{
			header: t('Common_Center'),
			accessor: 'center.name',
			sortable: true
		},
		{
			header: t('Term_SchoolYear'),
			accessor: 'schoolYearName',
			sortable: true
		},
		{
			header: t('Term_Type'),
			accessor: 'typeName',
			cell: (typeName) => typeName && t(`TermType_${typeName}`),
			sortable: false
		},
		{
			header: t('Term_StartDate'),
			accessor: 'startDate',
			cell: (startDate) => (ui.formatDate(startDate)),
			sortable: true
		},
		{
			header: t('Term_EndDate'),
			accessor: 'endDate',
			cell: (endDate) => (ui.formatDate(endDate)),
			sortable: true
		},
		{
			header: t('Term_AllowBooking'),
			accessor: 'allowBooking',
			sortable: true,
			cell: (allowBooking) => (ui.formatBoolean(allowBooking))
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => (<Link to={`/terms/${id}`} className='btn btn-teal'>
				<FontAwesomeIcon icon={row.isReadonly ? faEye : faPenToSquare} /> {t(row.isReadonly ? 'Common_View' : 'Common_Edit')}</Link>)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath='/terms/new' />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);